import EmployeeHistoryGroupComponent from "../components/EmployeeHistoryGroup";
import useEmployeeHistoryGroup from "../hooks/useEmployeeHistoryGroup";

const EmployeeHistoryGroup = () => {
    const EmployeeHistoryGroupProps = useEmployeeHistoryGroup();
    return <EmployeeHistoryGroupComponent {...EmployeeHistoryGroupProps} />;
};

export default EmployeeHistoryGroup;
